import { store, Model } from "hybrids";
import { get, post, put } from "~/utils/api";
import Broadcast from "./Broadcast";
import PaymentRequest from "./PaymentRequest";

interface BroadcastDonation {
  id: string;
  broadcast: Broadcast;
  amount: number;
  tip: number;
  currency: string;
  paymentRequest: PaymentRequest;
  paymentMethod: string;
  paymentId: string;

  // computed
  total: number;
  disabled: boolean;
}

const BroadcastDonation: Model<BroadcastDonation> = {
  id: true,
  broadcast: Broadcast,
  amount: 0,
  tip: 0,
  currency: "USD",
  paymentRequest: PaymentRequest,
  paymentMethod: "",
  paymentId: "",

  total: ({ amount, tip }) => amount + tip,
  disabled: ({ amount, tip }) => !amount || amount < 1 || tip < 0,

  [store.connect]: {
    get: (id) => get("/broadcast_donations/:id", id),
    set: (id, values) => {
      if (values) {
        if (!id) {
          return post("/broadcast_donations", values);
        }
        if (values?.paymentId && values?.paymentMethod) {
          return post(`/broadcast_donations/${id}/complete`, values);
        }

        return put("/broadcast_donations/:id", id, values);
      }

      throw Error("Unsupported action");
    },
  },
};

export default BroadcastDonation;
